const colors = {
  black: '#242220',
  white: '#ffffff',
  systemRed: '#FF4A42',
  systemYellow: '#FFE20A',
  systemGreen: '#47E171',
  systemLink: '#5A5859',
  systemLinkHover: '#92908E',
  systemLinkActive: '#5A5859',
  gray: {
    1: '#5A5859',
    2: '#92908E',
    3: '#C9C8C6',
    4: '#E7E6E4',
    5: '#F3F2F2',
    6: '#FAFAFA'
  },
  flamingo: {
    1: '#F65996',
    2: '#FC92D3',
    3: '#FBC6ED'
  },
  fire: {
    1: '#FF6738',
    2: '#FF9270',
    3: '#FFC4B3'
  },
  poppy: {
    1: '#FFA229',
    2: '#FFBD66',
    3: '#FFD28F'
  },
  lemon: {
    1: '#FFE20A',
    2: '#FFED66',
    3: '#FFF5A7'
  },
  chartreuse: {
    1: '#DBF320',
    2: '#E9F878',
    3: '#EFFA9B'
  },
  mojito: {
    1: '#47E171',
    2: '#84EBA0',
    3: '#B8F9BF'
  },
  azure: {
    1: '#15B3FF',
    2: '#78D3FF',
    3: '#BDEDFF'
  },
  ultraviolet: {
    1: '#A475FF',
    2: '#C6AAFE',
    3: '#DECFFC'
  }
};

export { colors, colors as default };
//# sourceMappingURL=Colors.js.map
